import * as React from 'react';
import seedrandom from 'seedrandom';

import { ITableColumn } from './index';
import PropertyUtil from '../../../util/PropertyUtil';

interface ITableBodyProps {
    isLoading?: boolean;
    rowCount: number;
    onRowClick?: (id: string | number) => void;
    columns: ITableColumn[];
    idField: string;
    data: object[];
}

const TableBody: React.StatelessComponent<ITableBodyProps> = (props) => {
    const rng = seedrandom('table');
    const rows: JSX.Element[] = [];

    for (let i = 0; i < props.rowCount; i++) {
        const cells: JSX.Element[] = [];
        let isActive = false;
        let isSkeleton = false;

        for (let j = 0; j < props.columns.length; j++) {
            const key = `cell-${i}-${j}`;
            if (props.isLoading) {
                cells.push(
                    <td key={key}>
                        <div className="loading-cell pt-skeleton" style={{ width: rng() * 30 + 20 + '%' }} />
                    </td>
                );
                isActive = true;
                isSkeleton = true;
            } else if (props.data && props.data[i]) {
                const cellValue = PropertyUtil.DeepFind(props.data[i], props.columns[j].mapping);
                const format = props.columns[j].format;
                let cellString = '';
                if (props.columns[j].type) {
                    switch (props.columns[j].type) {
                        case 'date':
                            const date = new Date(cellValue as Date);
                            if (format) {
                                cellString = format(date.toISOString());
                            } else {
                                cellString = (date as Date).toString();
                            }
                            break;
                        default:
                            cellString = cellValue ? cellValue.toString() : '';
                    }
                } else {
                    if (format) {
                        cellString = format(cellValue ? cellValue.toString() : '');
                    } else {
                        cellString = cellValue ? cellValue.toString() : '';
                    }
                }
                cells.push(<td key={key}>{cellString}</td>);
                isActive = true;
            } else {
                cells.push(<td key={key} />);
            }
        }

        const rowClass: string[] = [];
        if (!isActive) {
            rowClass.push('inactive');
        }
        if (props.onRowClick && isActive) {
            rowClass.push('hoverable');
        }
        if (isSkeleton) {
            rowClass.push('skeleton-row');
        }

        const id: number | string = props.data && props.data[i] ? props.data[i][props.idField] : undefined;
        const clickAction =
            id && props.onRowClick
                ? () => {
                      (props.onRowClick as Function)(id);
                  }
                : undefined;
        rows.push(
            <tr key={`row-${i}`} className={rowClass.join(' ')} onClick={clickAction}>
                {cells}
            </tr>
        );
    }

    return <tbody>{rows}</tbody>;
};

export default TableBody;



// WEBPACK FOOTER //
// ./src/components/common/table/TableBody.tsx